import Router from 'next/router'
import { Loading } from '~/app/components/common/LoadingProvider'
import { useState, useEffect, PropsWithChildren } from 'react'

/**
 * CSR 페이지 이동시 Loading 을 띄워주는 Component
 * useLoading 공통 hooks 를 사용하는 경우 페이지들 과의 충돌로 인해 loading 이 미노출되는 현상 존재.
 * 이를 해결하기 위해 해당 Component 는 useState 를 통해 Loading 을 직접 노출함.
 */
const RouterLoading = ({ children }: PropsWithChildren) => {
  const [isLoading, setLoading] = useState(false)
  useEffect(() => {
    const start = () => {
      setLoading(true)
    }
    const end = () => {
      setLoading(false)
    }

    Router.events.on('routeChangeStart', start)
    Router.events.on('routeChangeComplete', end)
    Router.events.on('routeChangeError', end)

    return () => {
      Router.events.off('routeChangeStart', start)
      Router.events.off('routeChangeComplete', end)
      Router.events.off('routeChangeError', end)
    }
  }, [])

  return (
    <>
      {children}
      {isLoading && <Loading />}
    </>
  )
}

export default RouterLoading
